import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { useWatch } from 'react-hook-form';
import { isBlockLabelLayout } from './hasBlockLabelLayout.ts';

/**
 * Preset dell'editor dell'etichetta in base ai valori correnti del form di
 * configurazione: con "a blocco" effettivo aggiunge il pulsante "Accapo".
 */
export function useLabelMenuPreset() {
  const [type, kind, labelLayout, isTableColumn] = useWatch({
    name: ['type', 'kind', 'layout.labelLayout', 'layout.isTableColumn'],
  });

  return isBlockLabelLayout({ type, kind, labelLayout, isTableColumn })
    ? MenuPresets.MinimalWithReturn
    : MenuPresets.Minimal;
}
